// test697
(697 && 0);
